export default __webpack_public_path__ + "static/media/toShow-7-min.c5a8679e.jpg";